module.exports = __webpack_public_path__ + "img/loan-application-active.8b529d82.svg";